import { render, staticRenderFns } from "./select-value.vue?vue&type=template&id=3e109ca1&"
import script from "./select-value.vue?vue&type=script&lang=js&"
export * from "./select-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports